export const updateError = (errorInfo, dispatch) => {
  dispatch({
    type: 'TRIGGER_ERROR',
    payload: errorInfo,
  });
};

export const clearError = (dispatch) => dispatch({ type: 'CLEAR_ERROR' });

export const updateNotifList = (notifList, dispatch) =>
  dispatch({
    type: 'UPDATE_NOTIF_LIST',
    payload: notifList,
  });

export const updateCurNotifDetails = (curNotifDetails, dispatch) =>
  dispatch({
    type: 'UPDATE_CUR_NOTIF_DETAILS',
    payload: curNotifDetails,
  });

export const updateContactList = (contactList, dispatch) =>
  dispatch({
    type: 'UPDATE_CONTACT_LIST',
    payload: contactList,
  });

export const updateNotifInternal = (notifInternal, dispatch) =>
  dispatch({
    type: 'UPDATE_NOTIF_INTERNAL',
    payload: notifInternal,
  });

export const updateCurContact = (curContact, dispatch) =>
  dispatch({
    type: 'UPDATE_CUR_CONTACT',
    payload: curContact,
  });

export const updateRegCodesList = (regCodesList, dispatch) =>
  dispatch({
    type: 'UPDATE_REG_CODES_LIST',
    payload: regCodesList,
  });

export const updateContactNames = (contactNames, dispatch) =>
  dispatch({
    type: 'UPDATE_CONTACT_NAMES',
    payload: contactNames,
  });

export const updateStandbyInspectorsList = function (
  standbyInspectorsList,
  dispatch
) {
  dispatch({
    type: 'UPDATE_STANDBY_INSPECTORS_LIST',
    payload: standbyInspectorsList,
  });
};

export const updateCurStandbyInspector = (curStandbyInspector, dispatch) =>
  dispatch({
    type: 'UPDATE_CUR_STANDBY_INSPECTOR',
    payload: curStandbyInspector,
  });

export const updatePermissions = (permissions, dispatch) =>
  dispatch({
    type: 'UPDATE_PERMISSIONS',
    payload: permissions,
  });
